import React from 'react';
import PropTypes from 'prop-types'
import { Switch } from "./index";
import { useController, useFormContext } from "react-hook-form";

const ControlSwitch = ({ name, handleChange, labelOff, labelOn }) => {
  const { control } = useFormContext()
  const {
    field: { value, onChange, ref, ...inputProps },
  } = useController({ name, control })

  const onChangeExtend = newValue => {
    onChange(newValue)
    handleChange(name, newValue)
  }

  return (
    <Switch
      checked={value}
      labelOff={labelOff}
      labelOn={labelOn}
      onChange={onChangeExtend}
      inputRef={ref}
      {...inputProps}
    />
  )
}

ControlSwitch.defaultProps = {
  handleChange: () => {}
}

ControlSwitch.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  defaultValue: PropTypes.any,
  handleChange: PropTypes.func,
  labelOff: PropTypes.string,
  labelOn: PropTypes.string,
}

export default ControlSwitch;
